<template>
    <ul ref="popper" class="lst_select" v-show="$parent.isShow">
        <li v-for="(option, index) in innerOptions" v-bind:class="{on: option.selected}" @mouseover="onMouseover(index)">
            <a href="#" tabindex="-1" @click.stop.prevent="onClickOption(index)">{{option.label}}</a>
        </li>
    </ul>
</template>

<script>
    import Popper from 'element-ui/lib/utils/vue-popper'
    import scrollIntoView from 'element-ui/lib/utils/scroll-into-view';

    export default {
        name: "CustomSelectList",

        props: {
            options: {
                type: Array,
                required: true
            },

            hoverIndex: {
                type: Number
            }
        },

        data() {
            return {
                innerHoverIndex: this.hoverIndex
            }
        },

        mixins: [Popper],

        watch: {
            '$parent.isShow'(isShow) {
                this.$nextTick(function () {
                    if (isShow) {
                        this.updatePopper();
                        this.scrollIntoView();
                    } else {
                        this.destroyPopper();
                    }
                });
            },

            hoverIndex(newValue) {
                this.innerHoverIndex = newValue;
                this.$nextTick(function () {
                    this.scrollIntoView();
                });
            }
        },

        computed: {
            innerOptions() {
                return this.options.map((option, index) => ({
                    ...option,
                    selected: this.innerHoverIndex === index
                }));
            }
        },

        methods: {
            scrollIntoView() {
                scrollIntoView(this.$el, this.$el.querySelector('li.on'));
            },

            onMouseover(index) {
                this.innerHoverIndex = index;
            },

            onClickOption(index) {
                this.$emit('selectOption', index);
            }
        },

        mounted() {
            this.referenceElm = this.$parent.$refs.reference;
        },
    }
</script>

<style scoped>

</style>